export const money = (amount) => {
  return window.shopMoneyFormat
    .replace('{{amount}}', (parseFloat(amount) / 100).toLocaleString(undefined, { maximumFractionDigits: 2 }))
    .replace('{{amount_with_comma_separator}}', (parseFloat(amount) / 100).toLocaleString(undefined, { maximumFractionDigits: 2 }))
}